import {BASE_ELEMENT_IDS} from "../BaseDOM";
import events from "../../events/EventsObservable";
import IMadmaxMessage from "./IMadmaxMessage";
import IUIMessages from "./IUIMessages";
import {inject, injectable} from "inversify";
import IScreenData from "../screen/IScreenData";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig, { CONFIG_PARAMS } from "../../system/SystemConfig";

export const UIMESSAGES_EVENTS = {
    "UIMESSAGE_OPEN": "UIMESSAGE_OPEN",
    "UIMESSAGE_CLOSE": "UIMESSAGE_CLOSE",
    "UIMESSAGE_DESTROY": "UIMESSAGE_DESTROY"
};

@injectable()
export default class UIMessages implements IUIMessages {

    private _messages: Array<IMadmaxMessage>;
    private _width: number;
    private _height: number;
    private _closeTimeout: number;

    private _wrap: HTMLElement;
    private _container: HTMLElement;
    private isBellot: boolean;

    constructor(@inject(SERVICE_IDENTIFIER.SystemConfig) systemConfig: SystemConfig) {
        this.isBellot = systemConfig.get(CONFIG_PARAMS.BRAND_NAME)?.toLowerCase() === 'bellot';

        this._messages = [];

        events.subscribe(UIMESSAGES_EVENTS.UIMESSAGE_OPEN, this._onOpenMessage.bind(this));
        events.subscribe(UIMESSAGES_EVENTS.UIMESSAGE_CLOSE, this._onCloseMessage.bind(this));
        events.subscribe(UIMESSAGES_EVENTS.UIMESSAGE_DESTROY, (e,msg) => this._onDestroyMessage.call(this,msg));

        this._width = null;
        this._height = null;
        this._closeTimeout = null;
    }

    create(parent: HTMLElement) {
        this._wrap = document.createElement("div");
        this._wrap.classList.add("mx-messages");
        this._wrap.id = BASE_ELEMENT_IDS.MESSAGES;

        this._container = document.createElement("div");
        this._container.classList.add("mx-messages-container");
        this._wrap.appendChild(this._container);
        $(this._wrap).hide();

        parent.appendChild(this._wrap);
        // this._resize();
    }

    /**
     * @param {MadmaxMessage} message
     */
    addMessage(message: IMadmaxMessage) {

        this._container.appendChild(message.getElement());

        if(!this._messages.includes(message)) {
            this._messages.push(message);
        }
    }

    _onOpenMessage() {
        this.blurGame();

        clearTimeout(this._closeTimeout);

        $(this._wrap).css("opacity", 1);
        $(this._wrap).show();

        this.showHighestPriorityActiveMsg();
    }

    _onCloseMessage() {
        this.showHighestPriorityActiveMsg();

        clearTimeout(this._closeTimeout);

        if(this._allClosed()) {
            this.unblurGame();
            $(this._wrap).css("opacity", 0);
            this._closeTimeout = setTimeout(() => {
                $(this._wrap).hide();
            }, 250);

        }
    }

    /**
     * Hide all messages and show only the message that is active and has the highest priority.
     */
    showHighestPriorityActiveMsg() {
        let topMsg: IMadmaxMessage|undefined = undefined;
        for (let msg of this._messages) {
            if (msg.isActive) {
                if (topMsg === undefined) {
                    topMsg = msg;
                } else if (msg.priority > topMsg.priority) {
                    topMsg = msg;
                }
            }
            msg.hide();
        }
        topMsg && topMsg.show();
    }

    _onDestroyMessage(destroyMsg) {
        this._messages = this._messages.filter(function(msg) { return msg.id !== destroyMsg.id; });
    }

    /**
     * @return {boolean}
     * @private
     */
    _allClosed() {
        let allClosed = true;

        for(let msg of this._messages) {
            if(msg.isMessageOpened()) {
                allClosed = false;
                break;
            }
        }

        return allClosed;
    }

    onResize(data: IScreenData) {
        if(!this.isBellot){
            $(this._container).css('transform', 'scale(' + data.containerScale + ')');
        }

        this._resize();
    }

    _resize() {
        // if(window.innerWidth && window.innerHeight) {
        this._width = window.innerWidth;
        this._height = window.innerHeight;
        // }
        //
        // if(this._width && this._height) {
        this._wrap.style.width = this._width + "px";
        this._wrap.style.height = this._height + "px";
        // }
    }

    blurGame() {
        $('#'+BASE_ELEMENT_IDS.CONTAINER).css('filter', 'blur(5px)');
    }

    unblurGame() {
        $('#'+BASE_ELEMENT_IDS.CONTAINER).css('filter', '');
    }
}